import React from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'

import homepageStyles from '../HomepageComponents/HomepageComponents.scss'
import styles from './PageSkeleton.scss'

const PageSkeleton = ({ page }) => {
  const skeletonContent = []
  const speed = 1
  const primaryColor = '#f3f3f3'
  const secondaryColor = '#ecebeb'
  const defaultLoader = (
    <ContentLoader
      height={100}
      width={50}
      speed={speed}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      className={styles['default-loader']}
      preserveAspectRatio='none'>
      <rect x='0' y='0' rx='0' ry='0' width='1000' height='450' />
    </ContentLoader>
  )

  if (page === 'homepage') {
    skeletonContent.push(
      <div key={page} className={`xs-row xs-12--negative`}>
        <div className={`${homepageStyles['grid-4-col']} ${homepageStyles['homepage-component-container']}`}>
          {[1, 2, 3, 4].map((comp, index) => (
            <div
              key={`homepage-skeleton-${index}`}
              className={`${homepageStyles['homepage-component']} ${
                homepageStyles[`homepage-component-${index + 1}`]
              }`}>
              <div className={homepageStyles['homepage-image-container']}>{defaultLoader}</div>
            </div>
          ))}
        </div>
      </div>,
    )
  }
  if (page === 'cms') {
    skeletonContent.push(
      <div key={page}>
        <ContentLoader
          height={100}
          width={100}
          speed={speed}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          className={styles.hero}
          preserveAspectRatio='none'>
          <rect x='0' y='0' rx='0' ry='0' width='1000' height='350' />
        </ContentLoader>
        <ContentLoader
          height={87}
          width={1000}
          speed={speed}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          className={`md-hidden ${styles.heading}`}
          preserveAspectRatio='none'>
          <rect x='0' y='0' rx='0' ry='0' width='350' height='70' />
          <rect x='0' y='80' rx='0' ry='0' width='1000' height='5' />
        </ContentLoader>
        <ContentLoader
          height={1000}
          width={1000}
          speed={speed}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          className='md-hidden'
          preserveAspectRatio='none'>
          <rect x='0' y='0' rx='0' ry='0' width='1000' height='350' />
          <rect x='0' y='380' rx='0' ry='0' width='1000' height='350' />
          <rect x='0' y='760' rx='0' ry='0' width='1000' height='350' />
        </ContentLoader>

        <ContentLoader
          height={72}
          width={1000}
          speed={speed}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          className={`xs-hidden md-block ${styles.heading}`}
          preserveAspectRatio='none'>
          <rect x='0' y='0' rx='0' ry='0' width='150' height='30' />
          <rect x='0' y='40' rx='0' ry='0' width='1000' height='2' />
        </ContentLoader>
        <ContentLoader
          height={360}
          width={1000}
          speed={speed}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          className='xs-hidden md-block'
          preserveAspectRatio='none'>
          <rect x='0' y='0' rx='0' ry='0' width='315' height='250' />
          <rect x='350' y='0' rx='0' ry='0' width='315' height='250' />
          <rect x='695' y='0' rx='0' ry='0' width='315' height='250' />

          <rect x='0' y='270' rx='0' ry='0' width='150' height='30' />
          <rect x='350' y='270' rx='0' ry='0' width='150' height='30' />
          <rect x='695' y='270' rx='0' ry='0' width='150' height='30' />
        </ContentLoader>
      </div>,
    )
  }

  if (page === 'taxonomy') {
    skeletonContent.push(
      <div className='xs-row' key={page}>
        <div className='xs-12--none'>
          <ContentLoader
            height={75}
            width={214}
            speed={2}
            primaryColor='#f3f3f3'
            secondaryColor='#ecebeb'
            style={{ width: '214px' }}>
            <rect x='0' y='8' rx='3' ry='3' width='200' height='30' />
            <rect x='0' y='46' rx='3' ry='3' width='85' height='16' />
          </ContentLoader>
        </div>
        <div className='xs-12--none sm-4--none md-3--none'>
          <ContentLoader
            height={82}
            width={214}
            speed={2}
            primaryColor='#f3f3f3'
            secondaryColor='#ecebeb'
            style={{ width: '214px' }}>
            <rect x='0' y='0' rx='3' ry='3' width='120' height='18' />
            <rect x='0' y='28' rx='0' ry='0' width='190' height='1' />
            <rect x='0' y='38' rx='3' ry='3' width='150' height='16' />
            <rect x='0' y='58' rx='3' ry='3' width='120' height='16' />
          </ContentLoader>
        </div>
        <div className='xs-12--none sm-4--none md-3--none'>
          <ContentLoader
            height={82}
            width={214}
            speed={2}
            primaryColor='#f3f3f3'
            secondaryColor='#ecebeb'
            style={{ width: '214px' }}>
            <rect x='0' y='0' rx='3' ry='3' width='94' height='18' />
            <rect x='0' y='28' rx='0' ry='0' width='190' height='1' />
            <rect x='0' y='38' rx='3' ry='3' width='150' height='16' />
            <rect x='0' y='58' rx='3' ry='3' width='120' height='16' />
          </ContentLoader>
        </div>
        <div className='xs-12--none sm-4--none md-3--none'>
          <ContentLoader
            height={82}
            width={214}
            speed={2}
            primaryColor='#f3f3f3'
            secondaryColor='#ecebeb'
            style={{ width: '214px' }}>
            <rect x='0' y='0' rx='3' ry='3' width='94' height='18' />
            <rect x='0' y='28' rx='0' ry='0' width='190' height='1' />
            <rect x='0' y='38' rx='3' ry='3' width='150' height='16' />
            <rect x='0' y='58' rx='3' ry='3' width='120' height='16' />
          </ContentLoader>
        </div>
        <div className='xs-12--none sm-4--none md-3--none'>
          <ContentLoader
            height={82}
            width={214}
            speed={2}
            primaryColor='#f3f3f3'
            secondaryColor='#ecebeb'
            style={{ width: '214px' }}>
            <rect x='0' y='0' rx='3' ry='3' width='94' height='18' />
            <rect x='0' y='28' rx='0' ry='0' width='190' height='1' />
            <rect x='0' y='38' rx='3' ry='3' width='150' height='16' />
            <rect x='0' y='58' rx='3' ry='3' width='120' height='16' />
          </ContentLoader>
        </div>
      </div>,
    )
  }

  return (
    <div className={`container ${styles['page-skeleton']} ${styles[`page-skeleton-${page}`]}`}>{skeletonContent}</div>
  )
}

PageSkeleton.propTypes = {
  page: PropTypes.string,
}

export default PageSkeleton
